import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { orpc } from '@/api/rpc/client';
// fallow-ignore-next-line circular-dependency
import { Route as pathlessAuthenticatedRoute } from '../../../route';
import { requireAnyPermission, requireModules } from '../../../route';
import {
  editExistingRuleSetCrumbs,
  settleLookup,
} from '../exceptionRuleSetCrumbs';

const EditExceptionRuleSetPage = lazyRouteComponent(
  () => import('../EditExceptionRuleSetPage'),
  'EditExceptionRuleSetPage',
);

function EditExceptionRuleSetRoutePage() {
  const { ruleSetId } = Route.useParams();
  return <EditExceptionRuleSetPage ruleSetId={ruleSetId} routeId={Route.id} />;
}

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/exception-rules/$ruleSetId/edit',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [
          { action: Action.Update, subject: Subject.APExceptionRuleSet },
        ],
      },
    },
  },
  component: EditExceptionRuleSetRoutePage,
  loader: async ({ params, context }) => {
    const ruleSet = await settleLookup(
      context.queryClient.fetchQuery(
        orpc.accountsPayable.exceptionRuleSets.get.queryOptions({
          input: { id: params.ruleSetId },
        }),
      ),
    );
    return editExistingRuleSetCrumbs(ruleSet?.name, params.ruleSetId);
  },
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Update, subject: Subject.APExceptionRuleSet },
      ],
    });
  },
});
